import { useHistory } from 'react-router-dom';
import { useCreateProject } from 'contexts/CreateProjectContext';
import { useEffect, useState } from 'react';
import CardWrapper from 'components/CardWrapper';
import Textarea from 'components/Inputs/Textarea';
import { FormattedMessage, useIntl } from 'react-intl';
import MainButton from 'components/MainButton';
import Select from 'components/Inputs/Select';
import { useStores } from 'index';
import { observer } from 'mobx-react';
import { useRouteMatch } from 'react-router-dom';
import OrSeperator from 'components/OrSeperator';
import InnerLinkHelper from 'screens/ProjectsListScreen/InnerLinkHelper';
import { ROUTE_LAB } from 'utils/constants/routes';

function TargetGroupScreen() {
  const match = useRouteMatch<{ step: string }>();
  const history = useHistory();
  const intl = useIntl();
  const { organizationsStore, dataStore } = useStores();

  const {
    setCurrentStep,
    projectTargetGroup,
    setProjectTargetGroup,
    currentStep
  } = useCreateProject();

  useEffect(() => {
    organizationsStore.getTargetGroups();
  }, []);

  useEffect(() => {
    if (match.params.step !== currentStep.toString()) {
      setCurrentStep(Number(match.params.step));
    }
  }, [match.params.step]);

  const [tmpTargetGroup, setTmpTargetGroup] = useState(
    projectTargetGroup || ''
  );

  return (
    <div className="l-item-stack-regular">
      <CardWrapper>
        <InnerLinkHelper
          href={
            ROUTE_LAB +
            '/' +
            dataStore.currentOrganizationId +
            '/settings/target-groups'
          }
          label={intl.formatMessage({ id: 'Manage target groups' })}
        />
        <Select
          name="target_group"
          label={<FormattedMessage id="Target group" />}
          normalFont={true}
          onFocus={() => {
            organizationsStore.getTargetGroups();
          }}
          onChange={(e) => setTmpTargetGroup(e.target.value)}
        >
          <option value="">
            <FormattedMessage
              id={
                dataStore.orgTargetGroups.size === 0
                  ? 'No target groups'
                  : 'Select target group'
              }
            />
          </option>
          {Array.from(dataStore.orgTargetGroups.values()).map((targetGroup) => (
            <option key={targetGroup.id} value={targetGroup.content!}>
              {targetGroup.name}
            </option>
          ))}
        </Select>
      </CardWrapper>
      <OrSeperator small={true} />
      <CardWrapper>
        <Textarea
          lines={6}
          largeFont={true}
          onChange={(e) => setTmpTargetGroup(e.target.value)}
          placeholder={intl.formatMessage({
            id: 'create project target group placeholder'
          })}
          name="question"
          normalFont={true}
          value={tmpTargetGroup}
        />
      </CardWrapper>
      <div className="l-item-stack-horizontal l-item-stack-horizontal--flex-end">
        <MainButton
          secondary={true}
          onClick={() => {
            setCurrentStep(currentStep - 1);
            history.goBack();
          }}
        >
          <FormattedMessage id="Back" />
        </MainButton>
        <MainButton
          onClick={() => {
            setProjectTargetGroup(tmpTargetGroup);
            setCurrentStep(currentStep + 1);
          }}
          disabled={!tmpTargetGroup}
        >
          <FormattedMessage id="Next" />
        </MainButton>
      </div>
    </div>
  );
}

export default observer(TargetGroupScreen);
